/* ==========================================================================
   Sparvya v2 — cart-photos.js
   The basket's personalisation studio. For every rakhi line item it renders
   one photo slot per unit. A chosen photo uploads straight to Cloudinary or
   ImgBB from the browser, and the returned URL is written onto the cart line
   as a property via POST /cart/change.js (merged — change.js replaces ALL
   properties on a line, so we always send the full set).
   Checkout is gated until every slot has a photo, or the customer ticks
   "I'll send photos on WhatsApp".
   ========================================================================== */

(function () {
  'use strict';

  var studio = document.querySelector('[data-cart-studio]');
  if (!studio) return;

  var cfg = {
    host:    studio.dataset.imageHost || 'cloudinary',
    cloud:   studio.dataset.cloudinaryCloud || '',
    preset:  studio.dataset.cloudinaryPreset || '',
    imgbb:   studio.dataset.imgbbKey || ''
  };

  var lines = Array.prototype.slice.call(studio.querySelectorAll('[data-line]'));
  var gate = studio.querySelector('[data-gate]');
  var gateMsg = studio.querySelector('[data-gate-msg]');
  var hatch = studio.querySelector('[data-whatsapp-later]');
  var checkoutBtn = studio.querySelector('[data-checkout-btn]');
  var cartForm = document.getElementById('cart-form');

  var uploadsConfigured = (cfg.host === 'imgbb' && cfg.imgbb) ||
                          (cfg.host === 'cloudinary' && cfg.cloud && cfg.preset);

  // Per-line property state, initialised from Liquid-rendered JSON
  var state = {};
  lines.forEach(function (line) {
    var props = {};
    try { props = JSON.parse(line.dataset.props || '{}') || {}; } catch (e) {}
    state[line.dataset.key] = props;
  });

  /* ---------- render slots ---------- */

  function slotDone(props, n) {
    var v = props['Photo ' + n];
    return typeof v === 'string' && v.indexOf('http') === 0;
  }

  function renderLine(line) {
    var key = line.dataset.key;
    var qty = parseInt(line.dataset.qty, 10) || 1;
    var wrap = line.querySelector('[data-slots]');
    if (!wrap) return;
    var props = state[key];

    var html = '';
    for (var n = 1; n <= qty; n++) {
      var done = slotDone(props, n);
      var name = props['Name ' + n] || '';
      html +=
        '<div class="slot' + (done ? ' slot--done' : '') + '" data-slot data-n="' + n + '">' +
          '<div class="slot__thumb">' +
            (done ? '<img src="' + props['Photo ' + n] + '" alt="Photo for rakhi ' + n + '">' : '📷') +
          '</div>' +
          '<div>' +
            '<div class="slot__label">' + (qty > 1 ? 'Rakhi ' + n : 'Your photo') + '</div>' +
            '<div class="slot__status">' + (done ? '✓ Photo added — tap to change' : 'Add the photo to go inside') + '</div>' +
            '<input class="slot__file" type="file" accept="image/*" aria-label="Photo for rakhi ' + n + '">' +
            '<div class="slot__bar" hidden><span></span></div>' +
            '<div class="slot__name">' +
              '<input type="text" maxlength="20" placeholder="Name on the card (optional)" value="' +
                String(name).replace(/"/g, '&quot;') + '" aria-label="Name on card for rakhi ' + n + '">' +
            '</div>' +
          '</div>' +
        '</div>';
    }
    wrap.innerHTML = html;

    wrap.querySelectorAll('[data-slot]').forEach(function (slot) {
      var n = parseInt(slot.dataset.n, 10);
      var file = slot.querySelector('.slot__file');
      var nameInput = slot.querySelector('.slot__name input');

      file.addEventListener('change', function () {
        var f = file.files && file.files[0];
        if (f) uploadPhoto(line, slot, n, f);
      });

      var t;
      nameInput.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          state[key]['Name ' + n] = nameInput.value.trim();
          pushProps(line);
        }, 700);
      });
    });
  }

  /* ---------- uploads ---------- */

  function uploadImage(f) {
    if (cfg.host === 'imgbb' && cfg.imgbb) {
      var fd = new FormData();
      fd.append('image', f);
      return fetch('https://api.imgbb.com/1/upload?key=' + encodeURIComponent(cfg.imgbb), { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (d) { return (d.data && d.data.url) || ''; });
    }
    var cd = new FormData();
    cd.append('file', f);
    cd.append('upload_preset', cfg.preset);
    return fetch('https://api.cloudinary.com/v1_1/' + cfg.cloud + '/image/upload', { method: 'POST', body: cd })
      .then(function (r) { return r.json(); })
      .then(function (d) { return d.secure_url || ''; });
  }

  function uploadPhoto(line, slot, n, f) {
    if (!uploadsConfigured) {
      alert('Photo upload is not set up yet — please order and send your photos on WhatsApp.');
      return;
    }
    if (f.size > 10 * 1024 * 1024) {
      slot.querySelector('.slot__status').textContent = 'That photo is over 10 MB — please pick a smaller one.';
      return;
    }
    var bar = slot.querySelector('.slot__bar');
    var fill = bar.querySelector('span');
    bar.hidden = false; fill.style.width = '30%';
    slot.querySelector('.slot__status').textContent = 'Uploading…';

    uploadImage(f).then(function (url) {
      if (!url) throw new Error('no url');
      fill.style.width = '70%';
      state[line.dataset.key]['Photo ' + n] = url;
      return pushProps(line);
    }).then(function () {
      fill.style.width = '100%';
      renderLine(line);
      updateGate();
    }).catch(function () {
      bar.hidden = true;
      slot.querySelector('.slot__status').textContent = 'Upload failed — try again, or send it on WhatsApp.';
    });
  }

  /* ---------- write properties to the cart line ---------- */

  function pushProps(line) {
    var key = line.dataset.key;
    var qty = parseInt(line.dataset.qty, 10) || 1;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, properties: state[key] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart change failed');
      return r.json();
    });
  }

  /* ---------- checkout gate ---------- */

  function counts() {
    var need = 0, done = 0;
    lines.forEach(function (line) {
      var qty = parseInt(line.dataset.qty, 10) || 1;
      var props = state[line.dataset.key];
      need += qty;
      for (var n = 1; n <= qty; n++) { if (slotDone(props, n)) done++; }
    });
    return { need: need, done: done };
  }

  function updateGate() {
    if (!checkoutBtn || !lines.length) return;
    var c = counts();
    var bypass = hatch && hatch.checked;
    var open = bypass || c.done >= c.need || !uploadsConfigured;

    if (gate) gate.hidden = open && c.done >= c.need;
    if (gateMsg) {
      gateMsg.textContent = c.done >= c.need
        ? '✓ All photos added — you’re ready to checkout.'
        : (c.need - c.done) + ' of ' + c.need + ' rakhis still need' + (c.need - c.done === 1 ? 's' : '') + ' a photo.';
      if (gate) gate.hidden = false;
    }
    checkoutBtn.classList.toggle('is-locked', !open);
  }

  if (hatch) {
    hatch.addEventListener('change', function () {
      updateGate();
      // Stamp the choice on the cart so the order shows it
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Photos': hatch.checked ? 'Customer will send on WhatsApp' : '' } })
      });
    });
  }

  if (cartForm && checkoutBtn) {
    cartForm.addEventListener('submit', function (e) {
      // Only intercept the checkout action, not quantity updates
      var submitter = e.submitter || document.activeElement;
      if (!submitter || submitter.name !== 'checkout') return;
      var c = counts();
      var bypass = hatch && hatch.checked;
      if (!bypass && uploadsConfigured && c.done < c.need) {
        e.preventDefault();
        updateGate();
        var firstEmpty = studio.querySelector('.slot:not(.slot--done)');
        if (firstEmpty) firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  /* ---------- boot ---------- */

  lines.forEach(renderLine);
  updateGate();
})();
